<div class="generic-selector-wrapper">
  <label *ngIf="label" class="form-label">{{ label | translate }}</label>

  <div class="select-trigger" (click)="toggleDropdown($event)" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
    [class.active]="isOpen" [class.disabled]="disabled || (isLoading && !isOpen)">
    <ng-container *ngIf="isLoading && !isOpen; else contentTpl">
      <span class="placeholder">{{ 'Loading...' | translate }}</span>
      <i class="pi pi-spin pi-spinner"></i>
    </ng-container>
    <ng-template #contentTpl>
      <ng-container *ngIf="selectedItem; else placeholderTpl">
        <span class="selected-value">{{ getDisplayValue(selectedItem) }}</span>
        <span class="clear-icon" (click)="clearSelection($event)">&times;</span>
      </ng-container>
      <ng-template #placeholderTpl>
        <span class="placeholder">{{ placeholder | translate }}</span>
        <i class="pi" [ngClass]="isOpen ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
      </ng-template>
    </ng-template>
  </div>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayMinWidth]="triggerWidth" (backdropClick)="toggleDropdown()" (detach)="isOpen = false"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'">

    <div class="overlay-dropdown" (click)="$event.stopPropagation()">
      <div class="search-container">
        <input type="text" [ngModel]="searchTerm" (ngModelChange)="onSearch($event)"
          [placeholder]="'Search...' | translate" class="search-input" autofocus />
        <i class="pi pi-search search-icon"></i>
      </div>

      <div class="items-list" (scroll)="onScroll($event)">
        <div *ngFor="let item of items" class="list-item"
          [class.selected]="selectedItem && item[config.idField] === selectedItem[config.idField]"
          (click)="selectItem(item)">
          {{ getDisplayValue(item) }}
        </div>

        <div class="loading-item" *ngIf="isLoading">
          <i class="pi pi-spin pi-spinner"></i> {{ 'Loading...' | translate }}
        </div>

        <div class="empty-item" *ngIf="!isLoading && items.length === 0">
          {{ 'No data found' | translate }}
        </div>
      </div>

      <div class="dropdown-footer">
        <small>{{ 'Shown' | translate }} {{ items.length }} {{ 'of' | translate }} {{ totalCount }}</small>
      </div>
    </div>
  </ng-template>
</div>
